import { isEmptyObject } from 'helpers/objectFunctions';
import * as yup from 'yup';
import { sumNumberOfNights } from '../utils/common';
import { getCodeValue } from 'views/pages/internal-commenting/utils';
import { FormatTravelDate } from 'store/slices/transfers';

const transFormData = (data) => {
    let origin = '';
    let destination = '';
    let costPrice = '';
    let sellingPrice = '';
    if (data && typeof data === 'object') {
        origin = data?.origin;
        destination = data?.destination;
        costPrice = data?.tCp || '-';
        sellingPrice = data?.finalPrice || '-';
    }
    return {
        origin,
        destination,
        costPrice,
        sellingPrice
    };
};

const routeSchema = yup.object().shape({
    origin: yup.string().required('Origin is required'),
    destination: yup.string().required('Destination is required'),
    transferType: yup.string().required('Transfer type is required'),
    cabType: yup.object().nullable().required('Cab type is required'),
    costPrice: yup
        .mixed()
        .test(
            'is-string-or-number',
            'Cost price must be a number or a string',
            (value) => typeof value === 'string' || typeof value === 'number'
        )
        .required('Cost price is required'),
    sellingPrice: yup
        .mixed()
        .test(
            'is-string-or-number',
            'Cost price must be a number or a string',
            (value) => typeof value === 'string' || typeof value === 'number'
        )
        .required('Selling Price price is required')
});

const transferSchema = yup.object().shape({
    origin: yup.string().required('Origin is required'),
    originType: yup.string().required('Orgin type is required'),
    destination: yup.string().required('Destination is required'),
    destinationType: yup.string().required('Destination Type is required'),
    transferType: yup.string().required('Transfer type is required'),
    cabType: yup.object().nullable().required('Cab type is required'),
    numberOfcabs: yup.number().nullable().defined('Number of cabs is required'),
    costPrice: yup.number().required('Cost price is required'),
    sellingPrice: yup.number().required('Selling price is required'),
    selectedRoute: yup.string().required('Selected route is required'),
    transfer: yup.string().required('Transfer is required'),
    route: yup.array().of(routeSchema)
});

export const validationSchema = yup.object().shape({
    data: yup.object().shape({
        dropPoint: yup.object().nullable().required('Drop point is required'),
        pickUpPoint: yup.object().nullable().required('Pick up point is required'),
        // transferType: yup.string().required('Transfer type is required'),
        cabType: yup.object().nullable().required('Cab type is required'),
        numberOfCabs: yup.number().required('Number of cabs is required'),
        totalCostPrice: yup.number().required('Total cost price is required'),
        totalSellingPrice: yup.number().required('Total selling price is required'),
        transfers: yup.array().of(transferSchema)
    })
});

export default transFormData;
export const fetchFlatArray = (array = [], key = '') => {
    if (!key) return false;
    return array.flatMap((item) => item?.[key]);
};

export const getFinalTransfersStr = (transfers = []) => {
    let transferArr = [];
    const { finalTransferDetails = [] } = transfers || {};
    transferArr = fetchFlatArray(finalTransferDetails, 'routes');
    return transferArr;
};
export const isValidArray = (arr = []) => {
    if (arr && typeof arr === 'object' && Array.isArray(arr)) {
        return true;
    }

    return false;
};
const getSelectedRouteInformation = (currentSelectedRoute = [], travelDate = '', numberOfCabs = null, transferSelfBookedStatus) => {
    if (isValidArray(currentSelectedRoute)) {
        return currentSelectedRoute?.map((item) => ({
            pickUpPoint: item?.originCode || '',
            dropPoint: item?.destinationCode || '',
            travelDate: item?.dateOfTravel,
            type: item?.transferType,
            modeCode: item?.cabType?.value,
            numberOfCabs,
            pickUpName: item?.pickUpPoint,
            dropName: item?.dropPoint,
            pickUpRouteName: item?.pickUpRouteName,
            dropRouteName: item?.dropRouteName,
            isSelfBooked: item?.isSelfBooked || false
        }));
    }
    return [];
};
export const getTransfer = (transfers = [], travelDate = '') => {
    if (!transfers || !Array.isArray(transfers) || transfers?.length <= 0) {
        return [];
    }
    return transfers?.map((transferItem) => ({
        pickUpPoint: transferItem?.route?.[0]?.originCode,
        dropPoint: transferItem?.route?.[transferItem?.route?.length - 1]?.destinationCode,
        travelDate: transferItem?.dateOfTravel || '',
        type: transferItem?.transferType,
        numberOfCabs: transferItem?.numberOfcabs === null ? null : Number(transferItem?.numberOfcabs),
        modeCode: transferItem?.cabType?.value,
        transferCode: transferItem?.code,
        isRouteAffectingPrice: transferItem?.isRouteAffectingPrice || false,
        pickUpName: transferItem?.route?.[0]?.pickUpPoint,
        dropName: transferItem?.route?.[transferItem?.route?.length - 1]?.dropPoint || '',
        pickUpRouteName: transferItem?.route?.[0]?.pickUpRouteName,
        dropRouteName: transferItem?.route?.[transferItem?.route?.length - 1]?.dropRouteName || '',
        isSelfBooked: transferItem?.isSelfBooked || false,
        routes: getSelectedRouteInformation(
            transferItem?.route,
            transferItem?.dateOfTravel,
            transferItem?.numberOfcabs === null ? null : Number(transferItem?.numberOfcabs),
            transferItem?.isSelfBooked
        )
    }));
};

const checkIfEverythingisSelfBooked = (transfers) => {
    if (!transfers) return false;
    if (!Array.isArray(transfers)) return false;

    return transfers.every((item) => {
        if (Array.isArray(item.routes) && item.routes.length > 0) {
            return item.isSelfBooked && item.routes.every((i) => (i.isRouteAffectingPrice ? i.isSelfBooked : true));
        }
        return item.isSelfBooked || false;
    });
};

export const makeFinalPostBody = (formikInstance, getCustomizeInformation, requirementCode) => {
    const { numberOfAdults = 0, numberOfChild, numberOfNight = 0, dateOfTravel, traceId } = getCustomizeInformation();
    const type = formikInstance?.values?.data?.transferType;
    const modeCode = formikInstance?.values?.data?.cabType?.value;
    const numberOfCabs = formikInstance?.values?.data?.numberOfCabs;
    const transfers = getTransfer(formikInstance?.values?.data?.transfers, dateOfTravel);
    const markAllTransfersSelfBooked =
        formikInstance.values?.data?.markAllTransfersSelfBooked || checkIfEverythingisSelfBooked(transfers) || false;
    return {
        numberOfAdults,
        numberOfChild,
        numberOfNight,
        dateOfTravel,
        traceId,
        requirement_code: requirementCode,
        type,
        modeCode,
        numberOfCabs: Number(numberOfCabs || 0),
        transfers,
        markAllTransfersSelfBooked
    };
};
export const makeNewTransferDetailsPayload = (formikInstance, getCustomizeInformation, requirementCode) => {
    const {
        numberOfAdults = 0,
        numberOfChild,
        numberOfNight = 0,
        dateOfTravel,
        traceId,
        routeInfo = [],
        isRouteAffectingPrice = false
    } = getCustomizeInformation();
    const values = formikInstance?.values?.data || {};
    const pickUpPoint = values?.pickUpPoint?.value;
    const dropPoint = values?.dropPoint?.value;
    // values?.transferType
    const type = null;
    const cabType = values?.cabType?.value;
    const modeCode = cabType;
    const numberOfCabs = Number(values?.numberOfCabs || 0);
    return {
        transferDetails: {
            numberOfAdults,
            numberOfChild,
            numberOfNight,
            dateOfTravel,
            transfers: [
                {
                    pickUpPoint,
                    dropPoint,
                    type,
                    modeCode,
                    numberOfCabs,
                    cabType,
                    isRouteAffectingPrice
                }
            ],
            routeInfo
        },
        traceId,
        requirement_code: requirementCode
    };
};

export const emptyFunction = () => {};

export const getRouteInformation = (routes = [], travelDate = '') => {
    if (routes && Array.isArray(routes)) {
        return routes?.map((item) => ({
            pickUpPoint: item?.originCode || '',
            dropPoint: item?.destinationCode || '',
            travelDate: FormatTravelDate(item?.travelDate || ''),
            type: item?.transferType,
            modeCode: item?.transferMode?.code,
            numberOfCabs: item?.numberOfCabs,
            isSelfBooked: item?.isSelfBooked || false,
            pickUpName: item?.pickUpPoint,
            dropName: item?.dropPoint,
            pickUpRouteName: item?.origin,
            dropRouteName: item?.destination
        }));
    }
    return [];
};

export const getTransfersFromApiResponse = (apiData = {}) => {
    const finalTransferDetails = apiData?.finalTransferDetails || [];
    return finalTransferDetails?.map((item) => {
        const transferRoutes = item?.routes || [];

        const pickUpPoint = transferRoutes?.[0]?.originCode || '';
        const dropPoint = transferRoutes?.[transferRoutes?.length - 1]?.destinationCode || '';
        const travelDate = FormatTravelDate(transferRoutes?.[0]?.travelDate || '');
        const type = item?.transferType;
        const numberOfCabs = item?.totalCabs;
        const modeCode = item?.modeCode;
        const transferCode = item?.code || '';
        const isRouteAffectingPrice = item?.isRouteAffectingPrice;
        const pickUpName = transferRoutes?.[0]?.pickUpPoint;
        const dropName = transferRoutes?.[transferRoutes?.length - 1]?.dropPoint;
        const pickUpRouteName = transferRoutes?.[0]?.origin;
        const dropRouteName = transferRoutes?.[transferRoutes?.length - 1]?.destination;
        const routes = getRouteInformation(transferRoutes, travelDate, numberOfCabs, item?.isRouteAffectingPrice);
        const isSelfBooked = item?.isSelfBooked || false;
        return {
            pickUpPoint,
            dropPoint,
            travelDate,
            type,
            numberOfCabs,
            modeCode,
            transferCode,
            isRouteAffectingPrice,
            pickUpName,
            dropName,
            pickUpRouteName,
            dropRouteName,
            routes,
            isSelfBooked
        };
    });
};

const getTransfersModeCodeAndTransferType = (formFieldGroup = [], key = 'transfers') => {
    const transferFormField = getCodeValue(formFieldGroup, 'key', key, 'fields');
    if (transferFormField && Array.isArray(transferFormField)) {
        const cabTypeField = transferFormField?.find((fieldItem) => fieldItem?.field?.key === 'cab_type') || '';
        const transferTypeField = transferFormField?.find((fieldItem) => fieldItem?.field?.key === 'transfer_type') || '';
        const numberOfCabsField = transferFormField?.find((fieldItem) => fieldItem?.field?.key === 'number_of_cabs') || '';

        const cabValue = cabTypeField?.field?.input_value?.value || '';
        const transferValue = transferTypeField?.field?.input_value?.value;
        const numberOfCabsFieldValue = numberOfCabsField?.field?.input_value?.value || null;
        // console.log('transferTypeField-123-', transferTypeField);
        return { type: transferValue, modeCode: cabValue, numberOfCabs: numberOfCabsFieldValue };
    }

    return { type: '', modeCode: '', numberOfCabs: '' };
};

export const makeFinalGetQuoteTransfersPostBody = ({
    GeneratedTransfersDataSlice,
    roomsAndGuests,
    dateOfTravel,
    formFieldGroups,
    traceId,
    tabValue
}) => {
    const { generatedTransferData = {} } = GeneratedTransfersDataSlice;
    const { onlineTransfers = {} } = generatedTransferData?.[tabValue] || {};
    const { quotePageTransferDetails = {} } = onlineTransfers || {};
    const { apiData = {} } = quotePageTransferDetails || {};
    if (!isEmptyObject(onlineTransfers) && !isEmptyObject(quotePageTransferDetails) && !isEmptyObject(apiData)) {
        const { numberOfAdults = 0, numberOfChild = 0 } = roomsAndGuests.reduce(
            (prev, curr) => {
                prev.numberOfAdults += Number(curr?.adult_count || 0);
                prev.numberOfChild += Number(curr?.child_count || 0);
                return prev;
            },
            { numberOfAdults: 0, numberOfChild: 0 }
        );
        const areaCount = formFieldGroups?.reduce((acc, curr) => {
            if (curr.key === 'hotel_and_sightseeings') {
                return acc + 1;
            }
            return acc;
        }, 0);
        const numberOfNight = sumNumberOfNights(formFieldGroups, areaCount);
        const { type = '', modeCode = '', numberOfCabs = 0 } = getTransfersModeCodeAndTransferType(formFieldGroups);
        const transfers = getTransfersFromApiResponse(apiData, dateOfTravel);
        const markAllTransfersSelfBooked = apiData?.markAllTransfersSelfBooked;
        return {
            dateOfTravel,
            modeCode,
            numberOfAdults,
            numberOfCabs,
            numberOfChild,
            numberOfNight,
            traceId,
            transfers,
            type,
            markAllTransfersSelfBooked
        };
    }
    return {};
};
export const scrollIntoFieldPosition = (id) => {
    // console.log('document id we are getting', id);
    const element = document.getElementById(id);
    element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
};
